var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.interval > 0)?_c('Vidle',{staticClass:"vidle-zero",attrs:{"syncKey":_vm.userId,"loop":true,"reminders":[_vm.interval / 2],"duration":_vm.interval},on:{"idle":_vm.onIdle,"remind":_vm.onRemind}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }